<span class="title-1">{{ data.title }}</span>
<span class="text" [innerHTML]="data.message"></span>
<footer>
  <button class="secondary" (click)="customAction()" *ngIf="data.customButtonText">{{ data.customButtonText }}</button>
  <button class="secondary" (click)="cancel()" *ngIf="data.cancelButtonText">{{ data.cancelButtonText }}</button>
  <button (click)="close()">{{ data.confirmButtonText }}</button>
</footer>
